/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  WebApiServicesDataTransferObjectsReplyServiceAddGuestReplyDto,
  WebApiServicesDataTransferObjectsReplyServiceAddMemberReplyDto,
  WebApiServicesDataTransferObjectsReplyServiceCreateReplyDto,
  WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDto,
  WebApiServicesDataTransferObjectsReplyServiceDeleteReplyDto,
  WebApiServicesDataTransferObjectsReplyServiceGetRepliesResultDto,
  WebApiServicesDataTransferObjectsReplyServiceGetReplyDto,
  WebApiServicesDataTransferObjectsReplyServicePromoteReplyDto,
  WebApiServicesDataTransferObjectsReplyServiceSaveHouseholdReplyDto,
  WebApiServicesDataTransferObjectsReplyServiceUpdateReplyDto,
} from '../models';
import {
    WebApiServicesDataTransferObjectsReplyServiceAddGuestReplyDtoFromJSON,
    WebApiServicesDataTransferObjectsReplyServiceAddGuestReplyDtoToJSON,
    WebApiServicesDataTransferObjectsReplyServiceAddMemberReplyDtoFromJSON,
    WebApiServicesDataTransferObjectsReplyServiceAddMemberReplyDtoToJSON,
    WebApiServicesDataTransferObjectsReplyServiceCreateReplyDtoFromJSON,
    WebApiServicesDataTransferObjectsReplyServiceCreateReplyDtoToJSON,
    WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDtoFromJSON,
    WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDtoToJSON,
    WebApiServicesDataTransferObjectsReplyServiceDeleteReplyDtoFromJSON,
    WebApiServicesDataTransferObjectsReplyServiceDeleteReplyDtoToJSON,
    WebApiServicesDataTransferObjectsReplyServiceGetRepliesResultDtoFromJSON,
    WebApiServicesDataTransferObjectsReplyServiceGetRepliesResultDtoToJSON,
    WebApiServicesDataTransferObjectsReplyServiceGetReplyDtoFromJSON,
    WebApiServicesDataTransferObjectsReplyServiceGetReplyDtoToJSON,
    WebApiServicesDataTransferObjectsReplyServicePromoteReplyDtoFromJSON,
    WebApiServicesDataTransferObjectsReplyServicePromoteReplyDtoToJSON,
    WebApiServicesDataTransferObjectsReplyServiceSaveHouseholdReplyDtoFromJSON,
    WebApiServicesDataTransferObjectsReplyServiceSaveHouseholdReplyDtoToJSON,
    WebApiServicesDataTransferObjectsReplyServiceUpdateReplyDtoFromJSON,
    WebApiServicesDataTransferObjectsReplyServiceUpdateReplyDtoToJSON,
} from '../models';

export interface ApiReplyAddGuestPostRequest {
    webApiServicesDataTransferObjectsReplyServiceAddGuestReplyDto?: WebApiServicesDataTransferObjectsReplyServiceAddGuestReplyDto;
}

export interface ApiReplyAddMemberPostRequest {
    webApiServicesDataTransferObjectsReplyServiceAddMemberReplyDto?: WebApiServicesDataTransferObjectsReplyServiceAddMemberReplyDto;
}

export interface ApiReplyCalendarEventUniqueIdGetRequest {
    eventUniqueId: string;
    timeIds?: Array<number>;
}

export interface ApiReplyCreatePostRequest {
    webApiServicesDataTransferObjectsReplyServiceCreateReplyDto?: WebApiServicesDataTransferObjectsReplyServiceCreateReplyDto;
}

export interface ApiReplyDeleteRequest {
    webApiServicesDataTransferObjectsReplyServiceDeleteReplyDto?: WebApiServicesDataTransferObjectsReplyServiceDeleteReplyDto;
}

export interface ApiReplyEventIdGetRequest {
    eventId: string;
}

export interface ApiReplyGetReplyByInviteGetRequest {
    eventId?: string;
    inviteId?: string;
    authCode?: string;
}

export interface ApiReplyPromotePostRequest {
    webApiServicesDataTransferObjectsReplyServicePromoteReplyDto?: WebApiServicesDataTransferObjectsReplyServicePromoteReplyDto;
}

export interface ApiReplySaveHouseholdPostRequest {
    webApiServicesDataTransferObjectsReplyServiceSaveHouseholdReplyDto?: WebApiServicesDataTransferObjectsReplyServiceSaveHouseholdReplyDto;
}

export interface ApiReplyUpdatePostRequest {
    webApiServicesDataTransferObjectsReplyServiceUpdateReplyDto?: WebApiServicesDataTransferObjectsReplyServiceUpdateReplyDto;
}

/**
 * 
 */
export class ReplyApi extends runtime.BaseAPI {

    /**
     * Adds a guest that is not a member to the event
     */
    async apiReplyAddGuestPostRaw(requestParameters: ApiReplyAddGuestPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Reply/addGuest`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiServicesDataTransferObjectsReplyServiceAddGuestReplyDtoToJSON(requestParameters.webApiServicesDataTransferObjectsReplyServiceAddGuestReplyDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDtoFromJSON(jsonValue));
    }

    /**
     * Adds a guest that is not a member to the event
     */
    async apiReplyAddGuestPost(requestParameters: ApiReplyAddGuestPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDto> {
        const response = await this.apiReplyAddGuestPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds a member from the register to the event
     */
    async apiReplyAddMemberPostRaw(requestParameters: ApiReplyAddMemberPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Reply/addMember`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiServicesDataTransferObjectsReplyServiceAddMemberReplyDtoToJSON(requestParameters.webApiServicesDataTransferObjectsReplyServiceAddMemberReplyDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDtoFromJSON(jsonValue));
    }

    /**
     * Adds a member from the register to the event
     */
    async apiReplyAddMemberPost(requestParameters: ApiReplyAddMemberPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDto> {
        const response = await this.apiReplyAddMemberPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * A calendar file (.ics) with the given times of the event, for \"Add to calendar\" after signing up
     */
    async apiReplyCalendarEventUniqueIdGetRaw(requestParameters: ApiReplyCalendarEventUniqueIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.eventUniqueId === null || requestParameters.eventUniqueId === undefined) {
            throw new runtime.RequiredError('eventUniqueId','Required parameter requestParameters.eventUniqueId was null or undefined when calling apiReplyCalendarEventUniqueIdGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.timeIds) {
            queryParameters['timeIds'] = requestParameters.timeIds;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Reply/calendar/{eventUniqueId}`.replace(`{${"eventUniqueId"}}`, encodeURIComponent(String(requestParameters.eventUniqueId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * A calendar file (.ics) with the given times of the event, for \"Add to calendar\" after signing up
     */
    async apiReplyCalendarEventUniqueIdGet(requestParameters: ApiReplyCalendarEventUniqueIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiReplyCalendarEventUniqueIdGetRaw(requestParameters, initOverrides);
    }

    /**
     * Creates new reply to event
     */
    async apiReplyCreatePostRaw(requestParameters: ApiReplyCreatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Reply/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiServicesDataTransferObjectsReplyServiceCreateReplyDtoToJSON(requestParameters.webApiServicesDataTransferObjectsReplyServiceCreateReplyDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDtoFromJSON(jsonValue));
    }

    /**
     * Creates new reply to event
     */
    async apiReplyCreatePost(requestParameters: ApiReplyCreatePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDto> {
        const response = await this.apiReplyCreatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async apiReplyDeleteRaw(requestParameters: ApiReplyDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiServicesDataTransferObjectsReplyServiceGetReplyDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Reply`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiServicesDataTransferObjectsReplyServiceDeleteReplyDtoToJSON(requestParameters.webApiServicesDataTransferObjectsReplyServiceDeleteReplyDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiServicesDataTransferObjectsReplyServiceGetReplyDtoFromJSON(jsonValue));
    }

    /**
     * 
     */
    async apiReplyDelete(requestParameters: ApiReplyDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiServicesDataTransferObjectsReplyServiceGetReplyDto> {
        const response = await this.apiReplyDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates new reply to event
     */
    async apiReplyEventIdGetRaw(requestParameters: ApiReplyEventIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiServicesDataTransferObjectsReplyServiceGetRepliesResultDto>> {
        if (requestParameters.eventId === null || requestParameters.eventId === undefined) {
            throw new runtime.RequiredError('eventId','Required parameter requestParameters.eventId was null or undefined when calling apiReplyEventIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Reply/{EventId}`.replace(`{${"EventId"}}`, encodeURIComponent(String(requestParameters.eventId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiServicesDataTransferObjectsReplyServiceGetRepliesResultDtoFromJSON(jsonValue));
    }

    /**
     * Creates new reply to event
     */
    async apiReplyEventIdGet(requestParameters: ApiReplyEventIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiServicesDataTransferObjectsReplyServiceGetRepliesResultDto> {
        const response = await this.apiReplyEventIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async apiReplyGetReplyByInviteGetRaw(requestParameters: ApiReplyGetReplyByInviteGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiServicesDataTransferObjectsReplyServiceGetReplyDto>> {
        const queryParameters: any = {};

        if (requestParameters.eventId !== undefined) {
            queryParameters['EventId'] = requestParameters.eventId;
        }

        if (requestParameters.inviteId !== undefined) {
            queryParameters['InviteId'] = requestParameters.inviteId;
        }

        if (requestParameters.authCode !== undefined) {
            queryParameters['AuthCode'] = requestParameters.authCode;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Reply/GetReplyByInvite`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiServicesDataTransferObjectsReplyServiceGetReplyDtoFromJSON(jsonValue));
    }

    /**
     * 
     */
    async apiReplyGetReplyByInviteGet(requestParameters: ApiReplyGetReplyByInviteGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiServicesDataTransferObjectsReplyServiceGetReplyDto> {
        const response = await this.apiReplyGetReplyByInviteGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Moves a reply from the waitlist to a place in the time
     */
    async apiReplyPromotePostRaw(requestParameters: ApiReplyPromotePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Reply/promote`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiServicesDataTransferObjectsReplyServicePromoteReplyDtoToJSON(requestParameters.webApiServicesDataTransferObjectsReplyServicePromoteReplyDto),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Moves a reply from the waitlist to a place in the time
     */
    async apiReplyPromotePost(requestParameters: ApiReplyPromotePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.apiReplyPromotePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Signs up the chosen people of a household through the primary member\'s personal invite
     */
    async apiReplySaveHouseholdPostRaw(requestParameters: ApiReplySaveHouseholdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Reply/saveHousehold`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiServicesDataTransferObjectsReplyServiceSaveHouseholdReplyDtoToJSON(requestParameters.webApiServicesDataTransferObjectsReplyServiceSaveHouseholdReplyDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDtoFromJSON(jsonValue));
    }

    /**
     * Signs up the chosen people of a household through the primary member\'s personal invite
     */
    async apiReplySaveHouseholdPost(requestParameters: ApiReplySaveHouseholdPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDto> {
        const response = await this.apiReplySaveHouseholdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates previous reply
     */
    async apiReplyUpdatePostRaw(requestParameters: ApiReplyUpdatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Reply/update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiServicesDataTransferObjectsReplyServiceUpdateReplyDtoToJSON(requestParameters.webApiServicesDataTransferObjectsReplyServiceUpdateReplyDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDtoFromJSON(jsonValue));
    }

    /**
     * Updates previous reply
     */
    async apiReplyUpdatePost(requestParameters: ApiReplyUpdatePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDto> {
        const response = await this.apiReplyUpdatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
